import { additionalPalette, makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  tickGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4
  },
  topN: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  netColumns: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 24
  },
  preview: {
    backgroundColor: additionalPalette.lightBlue.main,
    padding: '12px 16px',
    borderRadius: 4
  }
})

export default useStyles
